import { Injectable, input, InputSignal, signal, WritableSignal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IViewLevel } from '../../../shared/services/levels/difficulty-level';

@Injectable({
  providedIn: 'root'
})
export class AllStatus {

  currentLevel = signal(0);
  playerPointsLevel = signal(0);
  selectLevel = signal(0);
  editUserInWaiting = signal(true);
  isNewbie$ = signal(false);
  isDifficultyWindow = signal(false);
  isPractices = signal(true);
  valueDifficulty = signal<IViewLevel>({levelNow: 0, rqId: 0, result: {points: 0, maxPoints: 0, level: 0}});
  diceValue = signal(0);
  allCard: WritableSignal<any[]> = signal([]);
  displayProgressSpinner = signal(false);
  explanationData = signal({cardId: 0, level: 0, count: 0});
  explanationTxt = signal('');
  numberOfMoves = signal<number>(0);
  mentor = signal(false);

  isGoToFinish = signal(true);

  maxPointresultCard: number = 0;

  viewBlockDice = signal(true);

  isLoadRQ = signal(false);
  selectRQ = new BehaviorSubject<number>(0);

  valueSearchList = new BehaviorSubject<string>('');
  updateListRoom = new BehaviorSubject<boolean>(false);
  openFooter = new BehaviorSubject<boolean>(false);

  playerEndData: any;
  textSpinner: string = '';

  fullRoom = signal(false);

  nowCard = new BehaviorSubject<any>('');
  uuId$ = new BehaviorSubject<string>('');
  finalResult = new BehaviorSubject<number>(0);
  downTime$ = new BehaviorSubject<boolean>(false);
  changeLanguage$ = new BehaviorSubject<boolean>(false);

  refreshNotValid$ =  new BehaviorSubject(false);

  trainingMode$ = new BehaviorSubject(0);

  isRollDice: boolean = true;
  isAseccessButton: boolean = false;
  isPassBoll: boolean = false;
  isEndGame: boolean = false;
  isCollectionProcess: boolean = true;
  isIturning: boolean = true;
  
  isEditUserInWaiting: boolean = false;

  isRollDiceType: boolean = true;
  isRollDiceQuest: boolean = false;
  isNewListVariant: boolean = true;
  isAseccessButtonQuest: boolean = false;

  isShowExplanation: boolean = false;

  questField: Array<any> = [];

  activeLevel: Array<number> = [];

  txtCardInfo: string = '';

  isAutorization: boolean = false;

  constructor() { } 

  setOpenFooter(value: boolean){
    this.openFooter.next(value);
  }

  setUpdateListRoom(value: boolean){
    this.updateListRoom.next(value);
  }

  setValueSearchList(value: string){
    this.valueSearchList.next(value);
  }

  setChangeUuId(value: string){
    this.uuId$.next(value);
  }

  setChangeLanguage(value: boolean){
    this.changeLanguage$.next(value);
  }

  setRefreshNotValid(val: boolean){
    this.refreshNotValid$.next(val);
  }

  resetRefreshNotValid(){
    this.refreshNotValid$.next(false);
  }

  setEditUserInWaiting(value: boolean){
    this.editUserInWaiting.set(value);
  }

  setDisplayProgressSpinner(val: boolean){
    this.displayProgressSpinner.set(val);
  }

  setSelectRQ(val: number){
    this.selectRQ.next(val);
  }

  setSelectLevel(val: number){
    this.selectLevel.set(val);
  }

  setViewBlockDice(value: boolean){
    this.viewBlockDice.set(value);
  }

  setLoadRQ(value: boolean){
    this.isLoadRQ.set(value);
  }

  getEditUserInWaiting(){
    return this.editUserInWaiting();
  }

  setDice(value: number){
    this.diceValue.set(value);
  }

  getDice(){
    return this.diceValue();
  }

  clearCards(){
    this.allCard.set([]);
  }

  setCards(cards: any){
    this.allCard.update(item => [...item, cards]);
    //this.allCard.set(cards);
  }

  getCards(){
    return this.allCard();
  }

  setNowCard(card: any){
    this.nowCard.next(card);
  }

  clearNowCard(){
    this.nowCard.next('');
  }

  setTrainingMode(value: number){
    this.trainingMode$.next(value);
  }

  clearTrainingMode(){
    this.trainingMode$.next(0);
  }

  setViewPractices(value: boolean){
    this.isPractices.set(value);
  }

  setDifficultyWindow(value: boolean){
    this.isDifficultyWindow.set(value);
  }

  setDataDifficulty(value: IViewLevel){
    this.valueDifficulty.set(value);
  }

  clearDataDifficulty(){
    this.valueDifficulty.set({levelNow: 0, rqId: 0, result: {points: 0, maxPoints: 0, level: 0}});
  }

  setExplanationData(value: any){
    this.explanationData.set(value);
  }

  setExplanationTxt(value: any){
    this.explanationTxt.set(value);
  }

  clearExplanationTxt(){
    this.explanationTxt.set('');
  }

  incrementNumberOfMoves(){
    this.numberOfMoves.update(currentMoves => currentMoves + 1);
  }

  clearNumberOfMoves(){
    this.numberOfMoves.set(0);
  }

  setPlayerEndData(points: number, maxPoints: number, levels: any){
    this.playerEndData = {points, maxPoints, levels }
  }
  
  clearPlayerEndData(){
    this.playerEndData = {};
  }

  setMentor(vl: boolean){
    this.mentor.set(vl);
  }

  clearMentor(){
    this.mentor.set(false);
  }

  setFinalResult(value: number){
    this.finalResult.next(value);
  }

  clearFinalResult(){
    this.finalResult.next(0);
  }

  setDownTime(value: boolean){
    this.downTime$.next(value);
  }
}
